import { api } from "@/services/api"
import { useQuery } from "@tanstack/vue-query"
import type { MaybeRef } from "vue"
import type {
  CommonPaymentRequest,
  PaymentRequestStatus,
} from "./paymentRequest"

export type ListPaymentRequestsResponseItem =
  CommonPaymentRequest

export type ListPaymentRequestsFilter = {
  search?: string
  customerId?: string
  status?: PaymentRequestStatus
}

export type ListPaymentRequestsOrdering =
  | "createdAt"
  | "-createdAt"

export type ListPaymentRequestsQuery =
  ListPaymentRequestsFilter & {
    ordering?: ListPaymentRequestsOrdering
  } & Pagination

const listPaymentRequests = async (
  query?: ListPaymentRequestsQuery
): Promise<Paginate<ListPaymentRequestsResponseItem[]>> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<
      Paginate<ListPaymentRequestsResponseItem[]>
    >
  >("/services/payments/", { query })

  return {
    ...body,
    results: body.results.map((paymentRequest) => ({
      ...paymentRequest,
      createdAt: DateFns.parseISO(paymentRequest.createdAt),
      lastSentAt: paymentRequest.lastSentAt
        ? DateFns.parseISO(paymentRequest.lastSentAt)
        : null,
    })),
  }
}

export const usePaymentRequests = (
  query?: MaybeRef<ListPaymentRequestsQuery>
) =>
  useQuery({
    queryKey: [PAYMENT_REQUESTS_QUERY_KEY, query] as const,
    queryFn: ({ queryKey: [_, query_] }) =>
      listPaymentRequests(query_),
  })
